import { ACCEPTED_FILE_TYPES, MAX_FILE_SIZE_MB } from '../../utils/uploaded-files';
import { formatUserName } from '../../utils/utils';
import LiveKitFileList from '../LiveKitFileList';
import LiveKitModalClose from '../LiveKitModalClose';
import LiveKitPrimaryButton from '../LiveKitPrimaryButton';

import { Icon } from '@amigoapp/doca-react';

const LiveKitAttachmentsModal = ({
	fileInputRef,
	files,
	isSubmittingFile,
	provider,
	onClose,
	onRemoveFile,
	onSelectFiles
}) => (
	<div className="lk-modal-overlay lk-modal-overlay--fixed">
		<div className="lk-modal lk-modal--compact">
			<div className="lk-modal__head">
				<div>
					<h3 className="lk-attach__title">Exames e documentos</h3>
					<p className="lk-attach__subtitle">
						{formatUserName(provider.title, provider.name)} verá os arquivos ao entrar na sala.
					</p>
				</div>
				<LiveKitModalClose onClick={onClose} />
			</div>

			<button className="lk-dropzone" type="button" onClick={() => fileInputRef.current?.click()}>
				<span className="lk-dropzone__badge">
					<Icon className="lk-dropzone__icon" name="cloud-arrow-up" type="solid" />
				</span>
				<span className="lk-dropzone__label">{isSubmittingFile ? 'Enviando...' : 'Clique para selecionar'}</span>
				<span className="lk-dropzone__hint">PDF, JPG ou PNG · até {MAX_FILE_SIZE_MB} MB</span>
				<input
					ref={fileInputRef}
					multiple
					accept={ACCEPTED_FILE_TYPES}
					className="hidden-input"
					name="upload"
					type="file"
					onChange={onSelectFiles}
				/>
			</button>

			{files.length > 0 && <LiveKitFileList files={files} onRemoveFile={onRemoveFile} />}

			<div className="lk-attach__actions">
				<LiveKitPrimaryButton disabled={isSubmittingFile} onClick={onClose}>
					Fechar
				</LiveKitPrimaryButton>
			</div>
		</div>
	</div>
);

export default LiveKitAttachmentsModal;
